export const appMessages = {
  "window.title.main": "CodeNomad",
  "window.controls.minimize": "Minimize window",
  "window.controls.maximize": "Maximize or restore window",
  "window.controls.close": "Close window",
  "window.menu.ariaLabel": "Application menu",
  "window.menu.file": "File",
  "window.menu.edit": "Edit",
  "window.menu.view": "View",
  "window.menu.leftPanel": "Left panel",
  "window.menu.rightPanel": "Right panel",
  "window.menu.timeline": "Timeline",
  "window.menu.window": "Window",
  "window.menu.help": "Help",
  "window.menu.native.getUpdates": "Get Updates...",
  "window.menu.native.codenomadHelp": "CodeNomad Help",
  "window.menu.native.hide": "Hide CodeNomad",
  "window.menu.native.hideOthers": "Hide Others",
  "window.menu.native.showAll": "Show All",
  "window.menu.native.quit": "Quit CodeNomad",
  "window.menu.native.openFolder": "Open Project Folder",
  "window.menu.native.openTerminal": "Open Terminal Here",
  "window.menu.native.openIn": "Open Project In",
  "window.menu.native.closeWindow": "Close Window",
  "window.menu.native.undo": "Undo",
  "window.menu.native.redo": "Redo",
  "window.menu.native.cut": "Cut",
  "window.menu.native.copy": "Copy",
  "window.menu.native.paste": "Paste",
  "window.menu.native.pasteAndMatchStyle": "Paste and Match Style",
  "window.menu.native.delete": "Delete",
  "window.menu.native.selectAll": "Select All",
  "window.menu.native.reload": "Reload",
  "window.menu.native.forceReload": "Force Reload",
  "window.menu.native.devTools": "Toggle Developer Tools",
  "window.menu.native.actualSize": "Actual Size",
  "window.menu.native.zoomIn": "Zoom In",
  "window.menu.native.zoomOut": "Zoom Out",
  "window.menu.native.fullScreen": "Toggle Full Screen",
  "window.menu.native.newWindow": "New Window",
  "window.menu.native.minimize": "Minimize",
  "window.menu.native.maximize": "Maximize",
  "window.menu.native.zoom": "Zoom",
  "window.menu.native.bringAllToFront": "Bring All to Front",
  "app.launchError.title": "Unable to launch OpenCode",
  "app.launchError.description": "OpenCode could not start this workspace. Review the error output below or check your OpenCode settings.",
  "app.launchError.binaryPathLabel": "Binary path",
  "app.launchError.errorOutputLabel": "Error output",
  "app.launchError.openAdvancedSettings": "Open OpenCode Settings",
  "app.launchError.close": "Close",
  "app.launchError.closeTitle": "Close",
  "app.launchError.fallbackMessage": "Failed to launch workspace",
  "app.launchError.invalidConfig": "OpenCode configuration is invalid",

  "app.closeInstance.toast.error": "Failed to close project.",
  "app.closeInstance.toast.otherWindow": "{project} was closed from another window.",

  "emptyState.logoAlt": "CodeNomad logo",
  "emptyState.brandTitle": "CodeNomad",
  "emptyState.tagline": "Select a folder to start coding with AI",
  "emptyState.actions.selectFolder": "Select Folder",
  "emptyState.actions.selecting": "Selecting...",
  "emptyState.keyboardShortcut": "Keyboard shortcut: {shortcut}",
  "emptyState.examples": "Examples: {example}",
  "emptyState.multipleInstances": "You can have multiple instances of the same folder",

  "releases.upgradeRequired.title": "Upgrade required",
  "releases.desktop.checking": "Checking for a CodeNomad update…",
  "releases.desktop.current": "CodeNomad is up to date.",
  "releases.desktop.available": "CodeNomad {version} is available. Installation will restart the application.",
  "releases.desktop.install": "Install and restart",
  "releases.desktop.downloading": "Downloading and verifying the update…",
  "releases.desktop.restarting": "Saving windows and installing the update…",
  "releases.desktop.failed": "The update could not be completed. You can try again or download it from the releases page.",
  "releases.desktop.busy": "Another CodeNomad window is already checking for or installing an update.",
  "releases.upgradeRequired.message.withVersion": "Update to CodeNomad {version} to use the latest UI.",
  "releases.upgradeRequired.message.noVersion": "Update CodeNomad to use the latest UI.",
  "releases.upgradeRequired.action.getUpdate": "Get update",

  "releases.uiUpdated.title": "UI updated",
  "releases.uiUpdated.message": "UI is now updated to {version}.",

  "releases.devUpdateAvailable.title": "Update available",
  "releases.devUpdateAvailable.message": "A newer release is available: {version}.",
  "releases.devUpdateAvailable.action": "View release",

  "theme.mode.system": "System",
  "theme.mode.light": "Light",
  "theme.mode.dark": "Dark",
  "theme.toggle.title": "Theme: {mode}",
  "theme.toggle.ariaLabel": "Theme: {mode}",
} as const
